import { render } from "./UserIcon.vue?vue&type=template&id=63e265d8&scoped=true"
import script from "./UserIcon.vue?vue&type=script&lang=js"
export * from "./UserIcon.vue?vue&type=script&lang=js"

import "./UserIcon.vue?vue&type=style&index=0&id=63e265d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e265d8"],['__file',"src/components/UserIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63e265d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63e265d8', __exports__)) {
    api.reload('63e265d8', __exports__)
  }
  
  module.hot.accept("./UserIcon.vue?vue&type=template&id=63e265d8&scoped=true", () => {
    api.rerender('63e265d8', render)
  })

}


export default __exports__